import React from "react";
import {NotificationsContainer} from "./styled";
import {Message, MessageSections} from "../../components/message/message";
import BarekamText from "../../components/text";
import {Outlet} from "react-router-dom";

export const Notifications = () => {
    return (
        <NotificationsContainer>
            <BarekamText variant={"xl"} bold>
                <Message messageKey={'notifications'} sectionId={MessageSections.MAIN}/>
            </BarekamText>
            <Outlet/>
        </NotificationsContainer>
    );
}
